import { Component, OnInit } from '@angular/core';
import { PropertiesService, CreativeTemplateInterface } from '../properties.service';

import { TemplatesService } from '../templates.service';
import { TemplateInterface } from 'models/template.model';
import Swal from 'sweetalert2';
import { AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask } from '@angular/fire/storage';
import { AuthService } from '../shared/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-template-editor',
  templateUrl: './template-editor.component.html',
  styleUrls: ['./template-editor.component.scss']
})
export class TemplateEditorComponent implements OnInit {
  public editorContent: string = "Loading...";
  public selectedTemplate: TemplateInterface;

  private creativeHeadline: string;
  private creativeDescription: string;
  private creativeSubheadline: string;
  private creativeLink: string;
  private creativeImage: string;
  private trackingCodes: string;
  private pixelCode: string;
  ref: AngularFireStorageReference;
  task: AngularFireUploadTask;
  uploadProgress: any;
  downloadURL: any;

  constructor(private router: Router, private authService: AuthService, private afStorage: AngularFireStorage, private properties: PropertiesService, private templateService: TemplatesService) {


  }


  generateSafeSite() {
    Swal.fire({
      title: 'Confirm Create Safe Website',
      text: "This will build a safe website for you to use, continue?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, build it!'
    }).then((result) => {
      if (result.value) {
        this.useTemplate().then(success => {
          Swal.fire(
            'New Safe Website!',
            `You have successfully set a new safe website up!`,
            'success'
          ).then(result => {
            this.router.navigate(["preview"]);
          });
        }).catch(error => {
          Swal.fire(
            'Error creating safe website!',
            `We experienced some issues creating your safe website, please try again or submit a ticket.`,
            'error'
          );
        });
      }
    });
  }

  changeTemplate(event: Event, template: TemplateInterface) {
    event.stopImmediatePropagation();
    event.stopPropagation();
    console.log(`Setting template to ${template.title}`);
    this.properties.current.template = template;
  }

  selectTemplate(template: TemplateInterface) {
    if (this.selectedTemplate && this.selectedTemplate.previewUrl === template.previewUrl) {
      this.selectedTemplate = null;
    } else {
      this.selectedTemplate = template;
    }
  }

  ngOnInit() {
    //Preload current creative
    if (this.properties.current && this.properties.current.template && this.properties.current.template.creative) {
      const loadCreative: CreativeTemplateInterface = this.properties.current.template.creative;
      this.creativeDescription = loadCreative.description;
      this.creativeHeadline = loadCreative.headline;
      this.creativeImage = loadCreative.image;
      this.creativeLink = loadCreative.link;
      this.creativeSubheadline = loadCreative.subheadline;
    }

    if (this.properties.current && this.properties.current.template && this.properties.current.template.trackingCodes) {
      console.log('Loading tracking codes');
      this.trackingCodes = this.properties.current.template.trackingCodes;
    }
  }

  async useTemplate() {
    //Gather the variables
    const creative: CreativeTemplateInterface = {
      description: this.creativeDescription,
      headline: this.creativeHeadline,
      image: this.downloadURL,
      link: this.creativeLink,
      subheadline: this.creativeSubheadline
    }

    console.log('building template with variables', creative);
    await this.properties.setTemplateHTML(this.properties.current, this.properties.current.dirty_url, creative, this.trackingCodes ? this.trackingCodes : '', this.pixelCode ? this.pixelCode : '');
  }

  upload(event) {
    // this.afStorage.upload(`/ad_creatives/${this.authService.userData.uid}`, event.target.files[0]);

    const file = event.target.files[0];
    const filePath = `${this.authService.userData.uid}_${this.properties.current._id}`;
    const task = this.afStorage.upload(filePath, file).then(() => {
      const ref = this.afStorage.ref(filePath);
      const downloadURL = ref.getDownloadURL().subscribe(url => {
        const Url = url; // for ts
        this.downloadURL = url; // with this you can use it in the html
      });
    });
  }

  publish() {
    console.log("Publishing website with html...");
    console.log(this.editorContent);


  }

  loadCurrentTemplateHTML() {
    if (this.properties.current && this.properties.current.template && this.properties.current.template.html) {
      this.editorContent = this.properties.current.template.html;

    }
  }

}
